// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-question{
    margin-bottom: 35px;
    text-align: center;
}

:host {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
  }`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/incident-details/rear-ended/rear-ended.component.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB","sourcesContent":[".lr-question{\n    margin-bottom: 35px;\n    text-align: center;\n}\n\n:host {\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 auto;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
